import { render } from 'preact';

import '../scss/main.scss';

import App from './components/App';

const target = document.getElementById( 'tcc-map-root' );

if ( target ) {
	// Pass WP data props to App.
	const wpCountryPosts = JSON.parse( target.getAttribute( 'data-wp-countries' ) );
	const wpRegionTerms = JSON.parse( target.getAttribute( 'data-wp-regions' ) );
	const wpProgramTerms = JSON.parse( target.getAttribute( 'data-wp-programs' ) );

	render( <App wpCountryPosts={ wpCountryPosts } wpRegionTerms={ wpRegionTerms } wpProgramTerms={ wpProgramTerms } />, target );
}

